// 1) href -> pathname 안전 추출 (절대/상대/쿼리/해시 모두 대응)
export function getPathnameFromHref(href, { base, extraHosts = [] } = {}) {
  try {
    const url = new URL(href, base || window.location.origin);
    // 내부 라우팅 대상 호스트만 허용
    const allowedHosts = new Set(
      [
        base ? new URL(base).host : window.location.host,
        ...extraHosts.map((h) => new URL(h).host),
      ].filter(Boolean),
    );
    if (!allowedHosts.has(url.host)) {
      // 내부 호스트가 아니면 null 반환해서 외부 링크로 처리
      return null;
    }
    return url.pathname; // ex) "/nangman-center/word/7016"
  } catch {
    // URL 파싱 실패 시 단순 치환 백업(필요시)
    return href || null;
  }
}

/**
 * pathname -> { screen, articleId } 규칙 파싱
 *
 * 앱 메시지 핸들러 route 객체 전달용
 */
export function parseAppRoute(pathname) {
  if (!pathname) return null;
  const seg = pathname.split('/').filter(Boolean); // ['', 'customer', 'word', '7016'] -> ['customer','word','7016']

  // /nangman-center/:boardType/:id?
  if (seg[0] === 'customer' || seg[0] === 'nangman-center') {
    const boardType = seg[1]; // notice | word | event | essay | faq ...
    let id = seg[2]; // "7016" or undefined
    if (id && id.includes('?')) id = id.split('?')[0]; // 방어적 처리(혹시 모를 잔재)
    const articleId = id && /^\d+$/.test(id) ? parseInt(id, 10) : null;

    switch (boardType) {
      case 'notice':
      case 'word':
      case 'event':
      case 'essay':
      case 'faq':
        return { screen: boardType, articleId };
      default:
        return null;
    }
  }

  // /essay/:id?  (루트 레벨 에세이 경로가 따로 있을 경우)
  if (seg[0] === 'essay') {
    const id = seg[1];
    const articleId = id && /^\d+$/.test(id) ? parseInt(id, 10) : null;
    return { screen: 'essay', articleId };
  }

  // 필요한 다른 규칙들도 여기에 추가
  return null;
}
